import { styled } from '@mui/material';
import Button from '@mui/material/Button';

export const Styles = {
  RectangleBar: styled('div')({
    margin: '0 auto',
    height: '8px',
    backgroundColor: '#D9D9D9',
    marginBottom: '35px',
    marginTop: '-25px'
  }),

  RecordsText: styled('div')({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '17px',
    lineHeight: '27px',
    color: '#212529',
    marginBottom: '16px'
  }),

  ListContainer: styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    width: '100%'
  }),

  Row: styled('div')<{ $isDragging?: boolean }>(({ $isDragging }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '12px 16px',
    backgroundColor: $isDragging ? '#f0f7ff' : '#ffffff',
    borderBottom: '1px solid #e0e0e0',
    opacity: $isDragging ? 0.6 : 1,
    position: 'relative' as const,
    transition: 'background-color 0.15s',
    '&:hover': {
      backgroundColor: $isDragging ? '#f0f7ff' : '#fafafa'
    }
  })),

  RowOverlay: styled('div')({
    position: 'absolute' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    zIndex: 1,
    pointerEvents: 'none'
  }),

  DragHandle: styled('div')<{ $isDragging?: boolean }>(({ $isDragging }) => ({
    cursor: $isDragging ? 'grabbing' : 'grab',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    color: '#999',
    fontSize: '18px',
    userSelect: 'none' as const,
    flexShrink: 0
  })),

  OrderBadge: styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    backgroundColor: '#04682E',
    color: '#fff',
    fontSize: '13px',
    fontWeight: 600,
    flexShrink: 0
  }),

  Thumbnail: styled('img')({
    width: '80px',
    height: '60px',
    objectFit: 'cover',
    borderRadius: '4px',
    flexShrink: 0,
    backgroundColor: '#eee'
  }),

  ThumbnailEmpty: styled('div')({
    width: '80px',
    height: '60px',
    borderRadius: '4px',
    flexShrink: 0,
    backgroundColor: '#e0e0e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
    color: '#999'
  }),

  Title: styled('span')({
    flex: 1,
    fontSize: '15px',
    fontWeight: 500,
    color: '#333',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const
  }),

  ButtonsContainer: styled('div')({
    display: 'flex',
    gap: '8px',
    flexShrink: 0,
    zIndex: 2
  }),

  ActionButton: styled(Button, {
    shouldForwardProp: (prop) =>
      !['$bg', '$hover', '$text'].includes(prop as string)
  })<{ $bg: string; $hover: string; $text?: string }>(
    ({ $bg, $hover, $text }) => ({
      minWidth: 100,
      padding: '6px 14px',
      height: '36px',
      backgroundColor: $bg,
      color: $text || '#FFFFFF',
      borderRadius: '5px',
      fontSize: '13px',
      fontWeight: 400,
      textTransform: 'none' as const,
      '&:hover': {
        backgroundColor: $hover
      }
    })
  ),

  LimitDivider: styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '12px 16px',
    borderTop: '2px dashed #c0392b',
    borderBottom: '2px dashed #c0392b',
    backgroundColor: '#fff5f5',
    marginTop: '4px',
    marginBottom: '4px'
  }),

  LimitText: styled('span')({
    fontSize: '14px',
    fontWeight: 600,
    color: '#c0392b',
    whiteSpace: 'nowrap' as const
  }),

  SnackbarContainer: styled('div')({
    position: 'fixed' as const,
    bottom: '24px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1000
  })
};
